import { render, staticRenderFns } from "./ResponsibleFieldList.vue?vue&type=template&id=b04f4f5c&"
import script from "./ResponsibleFieldList.vue?vue&type=script&lang=js&"
export * from "./ResponsibleFieldList.vue?vue&type=script&lang=js&"
import style0 from "./ResponsibleFieldList.vue?vue&type=style&index=0&id=b04f4f5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports